import { NAVIGATION_LINKS_DATA } from '../../constants';
import { CONFIGURATION_STEPS, ConfigurationStepId, getConfigurationStep } from './eoaConfigurationSteps';

const configurationBasePath = NAVIGATION_LINKS_DATA.CONFIGURATION.path;
const firstConfigurationStepId = CONFIGURATION_STEPS[0].id;

interface ConfigurationLocation {
  eoaId?: string;
  stepId: ConfigurationStepId;
}

const configurationPath = (eoaId: string, stepId: ConfigurationStepId): string =>
  `${configurationBasePath}/${eoaId}/${stepId}`;

const configurationStepPath = (stepId: ConfigurationStepId): string => `${configurationBasePath}/${stepId}`;

const parseConfigurationLocation = (pathname: string): ConfigurationLocation | null => {
  const prefix = `${configurationBasePath}/`;
  if (!pathname.startsWith(prefix)) return null;

  const [first, second] = pathname.slice(prefix.length).split('/');
  if (second) {
    if (!first || getConfigurationStep(second) === undefined) return null;
    return { eoaId: first, stepId: second as ConfigurationStepId };
  }

  if (getConfigurationStep(first) === undefined) return null;
  return { stepId: first as ConfigurationStepId };
};

export {
  configurationBasePath,
  configurationPath,
  configurationStepPath,
  firstConfigurationStepId,
  parseConfigurationLocation,
};
